import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";

registerLocale("es", es)

export default function MyDatePicker({ scheduleDates, appointment, handleDateChange, disabled }) {
  const allowedDates = new Set(scheduleDates);

  const parseLocalDate = (dateStr) => {
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  const formatLocalDate = (date) => {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, "0"),
      String(date.getDate()).padStart(2, "0"),
    ].join("-");
  };

  return (
    <DatePicker
      className="input-base"
      disabled={disabled}
      selected={appointment.date ? parseLocalDate(appointment.date) : null}
      onChange={(date) => {
        if (!date) return;
        handleDateChange("date", formatLocalDate(date));
      }}
      placeholderText="Selecciona una fecha"
      dateFormat="dd-MM-yyyy"
      filterDate={(date) => allowedDates.has(formatLocalDate(date))}
      locale="es"
    />
  );
}
